/**
 * The refusal both partner administration pages show a non-administrator.
 *
 * The endpoints already refuse — every one of them goes through
 * `require_permission(..., "Partner")` and the policy allows only `admin` — so
 * nothing leaks without this. What it fixes is the page: without it a
 * non-administrator who types the URL gets the heading, an empty body and a
 * server error written for an administrator debugging a missing policy.
 *
 * Shared by the two routes rather than inlined twice, which is the only reason
 * it is a component at all. It mirrors the panel on the other administrator
 * pages (`admin/reporting.tsx`, `admin/users/index.tsx`).
 */

import { Link } from '@tanstack/react-router'
import { Button } from '@/common/components/button'
import { Icon } from '@/common/components/icon'
import { Stack } from '@/common/components/stack'
import { Text } from '@/common/components/text'

export function AdminOnly({ title }: { title: string }) {
  return (
    <Stack gap="24" style={{ padding: 24, height: '100%' }}>
      <Text as="h1" variant="h4" weight="bold">
        {title}
      </Text>
      <Stack gap="16" align="center" justify="center" style={{ flex: 1 }}>
        <Icon name="lock" size={48} style={{ color: '#999' }} />
        <Text as="h2" variant="bodyLg" weight="bold">
          Access Restricted
        </Text>
        <Text variant="body" color="muted" style={{ textAlign: 'center', maxWidth: 400 }}>
          Partner integrations are only available to administrators.
        </Text>
        <Link to="/properties">
          <Button>Go to Properties</Button>
        </Link>
      </Stack>
    </Stack>
  )
}
